import React, { FC } from 'react'
import { useTheme } from '@emotion/react'
import { QueryParamDropdown } from '../components/DropdownMenu/QueryParamDropdown'
import {
    defaultTimeFilterOption,
    TIME_FILTER_PARAM,
    timeFilterOptions,
} from './util'
import { FilterEventProps } from '../filter-events-util'

export const TimeFilter: FC<FilterEventProps> = ({
    onEvent,
    dataLayerEventName,
}) => {
    const theme = useTheme()
    const defaultOption = defaultTimeFilterOption(theme.kind)
    const options = timeFilterOptions
    return (
        <QueryParamDropdown
            defaultOption={defaultOption}
            menuOptions={options}
            name="Time Filter"
            label="When"
            originator="TimeFilter"
            queryParamName={TIME_FILTER_PARAM}
            clearPage={true}
            onEvent={onEvent}
            dataLayerEventName={dataLayerEventName}
        />
    )
}
